export default "__VITE_ASSET__BHLWirX3__"